import type { CareTeam, CareTeamParticipant } from 'fhir/r4';
import { v4 as uuid } from 'uuid';

import * as FHIRUtils from '../fhirutils';

export interface CareTeamMember {
  reference?: string | undefined;
  display?: string | undefined;
}

export function build(
  orgId: string,
  patientId: string,
  careteamId: string,
  outreachAssociates: CareTeamMember[] | undefined,
  rigisteredDietitians: CareTeamMember[] | undefined,
  careCoordinators: CareTeamMember[] | undefined,
  updatedBy: string
): CareTeam {
  if (!careteamId) {
    careteamId = uuid();
  }
  const careTeam: CareTeam = {
    resourceType: 'CareTeam',
    id: careteamId,
    subject: {
      reference: 'Patient/' + patientId,
    },
    participant: buildParticipants(outreachAssociates, rigisteredDietitians, careCoordinators, orgId),
  };

  if (careCoordinators) {
    careTeam.category = [
      {
        coding: [
          {
            code: 'LA28865-6',
            display: 'Longitudinal care-coordination focused care team',
            system: 'http://loinc.org',
          },
        ],
      },
    ];
  }
  if (orgId) {
    careTeam.identifier = [
      {
        system: 'https://projectwell.io/fhir/identifiers/org-id',
        value: orgId,
      },
    ];
  }

  return FHIRUtils.addUpdatedBy(careTeam, updatedBy);
}

function buildParticipants(
  outreachAssociates: CareTeamMember[] | undefined,
  rigisteredDietitians: CareTeamMember[] | undefined,
  careCoordinators: CareTeamMember[] | undefined,
  _orgId: string
) {
  let participants: CareTeamParticipant[] = [];
  if (outreachAssociates) {
    participants = participants.concat(
      outreachAssociates.map((outreachAssociate) => {
        return {
          role: [
            {
              coding: [
                {
                  system: 'http://snomed.info/sct',
                  code: '309396002',
                  display: 'Associate specialist',
                },
              ],
            },
          ],
          member: outreachAssociate,
        };
      })
    );
  }
  if (rigisteredDietitians) {
    participants = participants.concat(
      rigisteredDietitians.map((rigisteredDietitian) => {
        return {
          role: [
            {
              coding: [
                {
                  system: 'http://snomed.info/sct',
                  code: '159033005',
                  display: 'Dietitian',
                },
              ],
            },
          ],
          member: rigisteredDietitian,
        };
      })
    );
  }
  if (careCoordinators) {
    participants = participants.concat(
      careCoordinators.map((careCoordinator) => {
        return {
          role: [
            {
              coding: [
                {
                  system: 'http://snomed.info/sct',
                  code: '768820003',
                  display: 'Care coordinator',
                },
              ],
            },
          ],
          member: careCoordinator,
        };
      })
    );
  }

  return participants;
}
